import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=2f34f5f7"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"
import style0 from "./Queue.vue?vue&type=style&index=0&id=2f34f5f7&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
